var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChina = function SvgChina(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.667 10.8 2.666 1.867-1-3.067L13 7.667H9.7l-1.033-3-1 3H4.333L7 9.6l-1 3.067L8.667 10.8ZM13.1 13.1l-.767.167.734.3v.766l.5-.566.733.266-.433-.633.466-.6-.766.167-.467-.634v.767ZM14.233 10.833l-.566.5.766-.066.334.733.133-.767.767-.066-.667-.4.167-.767-.567.5-.667-.4.3.733ZM14.433 8.233l.234.767.233-.733h.767l-.6-.467.233-.767-.633.467-.6-.5.233.767-.633.433.766.033ZM13.1 5.567v.766l.467-.633.766.167-.466-.6.433-.634-.733.3-.5-.6V5.1l-.734.3.767.167Z",
    fill: "#FFE62E"
  })));
};
export default SvgChina;